import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { LiveLesson } from 'src/app/types/live-lesson-types';

@Component({
  selector: 'app-live-lesson-notification',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './live-lesson-notification.component.html',
  styleUrl: './live-lesson-notification.component.scss',
})
export class LiveLessonNotificationComponent {
  lesson = input.required<LiveLesson>();
}
